import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom }: Theme) => ({
  subLabel: {
    fontSize: 10,
  },
  subLabelNotFloating: {
    color: custom.grey[4],
    marginLeft: 5,
  },
}));
